import "regenerator-runtime/runtime";

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(waitForVendor);

import { delay } from 'redux-saga';
import { call, race, select, take } from 'redux-saga/effects';
import * as Vendor from './Vendor.reducer';
export function waitForVendor(vendor) {
  var timeout,
      start,
      hasExpired,
      isAvailable,
      _args = arguments;
  return regeneratorRuntime.wrap(function waitForVendor$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          timeout = _args.length > 1 && _args[1] !== undefined ? _args[1] : 3000;
          start = Date.now();

        case 2:
          if (!__CLIENT__) {
            _context.next = 15;
            break;
          }

          _context.next = 5;
          return select(Vendor.hasLoadingExpired, vendor, timeout);

        case 5:
          hasExpired = _context.sent;
          _context.next = 8;
          return select(Vendor.isAvailable, vendor);

        case 8:
          isAvailable = _context.sent;

          if (!(hasExpired || isAvailable)) {
            _context.next = 11;
            break;
          }

          return _context.abrupt("return", isAvailable);

        case 11:
          _context.next = 13;
          return race([take(Vendor.setAvailable().type), call(delay, timeout - (Date.now() - start))]);

        case 13:
          _context.next = 2;
          break;

        case 15:
          return _context.abrupt("return", false);

        case 16:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}